import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBag2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bag-2, luggage, buggage "><path d="M8.00195 3C7.58774 3 7.25195 3.33579 7.25195 3.75V7H8.75V21H15.25V7H8.75195V4.5H15.252V7H16.75V21H21.25C21.6642 21 22 20.6642 22 20.25V7.75C22 7.33579 21.6642 7 21.25 7H16.752V3.75C16.752 3.33579 16.4162 3 16.002 3H8.00195Z" fill="currentColor"/><path d="M2.75 7H7.25V21H2.75C2.33579 21 2 20.6642 2 20.25V7.75C2 7.33579 2.33579 7 2.75 7Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBag2;
